import { ServerCommunicationUtil } from 'utils/server_communication_util';

// API under app/controllers/my

export async function toggleSubscriptionStatus() {
  return fetch('/my/profile/toggle_subscription_status', {
    method: 'POST',
    headers: {
      ...ServerCommunicationUtil.defaultAuthHeaders()
    }
  }).then(response => {
    // from https://www.tjvantoll.com/2015/09/13/fetch-and-errors/
    if (!response.ok) {
      throw Error(`Fetch failed in My.js with '${response.statusText}' and '${response.status}'`);
    }
    return response;
  });
}
